export const SearchController = {
    index(): void {},
    suggest(): void {},
};
